import React from 'react';
import { Box, Button, Counter, FilterIcon } from '@razorpay/blade/components';

import { CustomFieldFilterToggleButtonProps } from './types';

/**
 * Icon button that shows/hides a CustomFieldFilter panel, with a count badge
 * for the number of applied filters. Shared by every screen that embeds the
 * custom-field filter (run payroll, custom reports).
 */
export const CustomFieldFilterToggleButton = ({
  isOpen,
  isDisabled,
  appliedCount,
  accessibilityLabel,
  onToggle,
}: CustomFieldFilterToggleButtonProps) => (
  <Box position="relative" display="inline-flex">
    <Button
      type="button"
      variant="secondary"
      size="medium"
      icon={FilterIcon}
      accessibilityLabel={accessibilityLabel}
      aria-expanded={isOpen}
      isDisabled={isDisabled}
      onClick={onToggle}
    />
    {appliedCount > 0 && (
      <Box position="absolute" top="-8px" right="-8px">
        <Counter value={appliedCount} color="primary" emphasis="intense" size="small" />
      </Box>
    )}
  </Box>
);
